
import Vue from "vue";
import { Task, TaskPriority } from "../../models/tasks/task";

const MENU_MARGIN = 4;

export default Vue.extend({
	data() {
		return {
			open: false,
			menuStyle: {} as any
		};
	},
	props: {
		value: {
			type: Number,
			default: TaskPriority.NONE
		},
		label: String,
		compact: Boolean,
		readonly: Boolean
	},
	computed: {
		priorities(): TaskPriority[] {
			return Task.PRIORITIES;
		},
		selectedChipStyle(): any {
			return this.chipStyle(this.value);
		},
		menuEl(): HTMLElement | undefined {
			return this.$refs.menu as HTMLElement | undefined;
		}
	},
	watch: {
		open(value: boolean) {
			if (value) {
				this.$nextTick(() => this.mountMenu());
			}
		}
	},
	methods: {
		colorFor(priority: TaskPriority): string {
			return Task.getColorForPriority(priority);
		},
		chipStyle(priority: TaskPriority): any {
			let color = this.colorFor(priority);
			if (priority == this.value || !this.compact) {
				return {
					backgroundColor: color,
					color: "#fff",
					borderColor: color
				};
			}
			return {
				backgroundColor: "#fff",
				color,
				borderColor: color
			};
		},
		toggle() {
			if (this.readonly) return;
			this.open = !this.open;
		},
		select(priority: TaskPriority) {
			if (this.readonly) return;
			if (priority != this.value) {
				this.$emit("input", priority);
			}
			this.open = false;
		},
		mountMenu() {
			let menu = this.menuEl;
			if (!menu || !this.open) return;
			document.body.appendChild(menu);
			let chip = this.$refs.chip as Vue;
			let rect = chip.$el.getBoundingClientRect();
			let menuHeight = menu.getBoundingClientRect().height;
			let style: any = {
				right: `${window.innerWidth - rect.right}px`
			};
			if (rect.bottom + MENU_MARGIN + menuHeight > window.innerHeight) {
				style.bottom = `${window.innerHeight - rect.top + MENU_MARGIN}px`;
			} else {
				style.top = `${rect.bottom + MENU_MARGIN}px`;
			}
			this.menuStyle = style;
		},
		removeMenuFromBody() {
			let menu = this.menuEl;
			if (menu && menu.parentNode == document.body) {
				document.body.removeChild(menu);
			}
		},
		isInside(target: EventTarget | null): boolean {
			if (!target) return false;
			if (this.$el.contains(target as Node)) return true;
			let menu = this.menuEl;
			return menu != null && menu.contains(target as Node);
		},
		onDocumentMouseDown(event: MouseEvent) {
			if (!this.open) return;
			if (this.isInside(event.target)) return;
			this.open = false;
		},
		onDocumentTouchStart(event: TouchEvent) {
			if (!this.open) return;
			if (this.isInside(event.target)) return;
			this.open = false;
		},
		onViewportChange(event: Event) {
			if (!this.open) return;
			if (this.menuEl && event.target instanceof Node && this.menuEl.contains(event.target)) return;
			this.open = false;
		}
	},
	created() {
		document.addEventListener("mousedown", this.onDocumentMouseDown);
		document.addEventListener("touchstart", this.onDocumentTouchStart);
		window.addEventListener("scroll", this.onViewportChange, true);
		window.addEventListener("resize", this.onViewportChange);
	},
	beforeDestroy() {
		this.removeMenuFromBody();
	},
	destroyed() {
		document.removeEventListener("mousedown", this.onDocumentMouseDown);
		document.removeEventListener("touchstart", this.onDocumentTouchStart);
		window.removeEventListener("scroll", this.onViewportChange, true);
		window.removeEventListener("resize", this.onViewportChange);
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
